import { useDispatch } from 'react-redux'
import { BasicSpeedDial, DialActions } from 'ui-components'

import {
  LAYER_TYPES,
  LAYER_TYPE_TITLE,
  setLayerType,
  setLayerTypeTitle,
  useLayerType
} from '~map-preview/states/layerType'

import {
  closeMapLegend,
  closeMapSettingsDrawer,
  openMapLegend,
  openMapSettingsDrawer,
  openTable,
  useIsAllToolsHidden,
  useIsMapLegendOpen
} from '~map-preview/states/ui'

function SpeedDial() {
  const dispatch = useDispatch()

  const layerType = useLayerType()
  const isHidden = useIsAllToolsHidden()
  const isMapLegendOpen = useIsMapLegendOpen()

  const handleChange = (action) => {
    if (action === DialActions.Table.value) {
      dispatch(openTable())
      return
    }

    if (action === DialActions.Heatmap.value) {
      dispatch(setLayerType(LAYER_TYPES.HEATMAP))
      dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.HEATMAP]))
      dispatch(closeMapSettingsDrawer())
      dispatch(closeMapLegend())
      return
    }

    dispatch(openMapSettingsDrawer())

    if (action === DialActions.Marker.value) {
      dispatch(setLayerType(LAYER_TYPES.MARKER))
      dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.MARKER]))
    }

    if (action === DialActions.Boundary.value) {
      dispatch(setLayerType(LAYER_TYPES.BOUNDARIES))
      dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.BOUNDARIES]))
      dispatch(openMapLegend())
    }

    if (action === DialActions.Hexagon.value) {
      dispatch(setLayerType(LAYER_TYPES.HEXAGON))
      dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.HEXAGON]))
      dispatch(openMapLegend())
    }
  }

  if (isHidden) return null

  return (
    <BasicSpeedDial
      showLegend={isMapLegendOpen}
      active={layerType}
      onChange={handleChange}
    />
  )
}

export { SpeedDial }
